<template>
  <div class="main-info">
    <!-- <BaseSkeleton class="main-info_header_icon" /> -->
    <div class="main-info_header">
      <div class="main-info_header_left">
        <div class="main-info_header_titles">
          <BaseSkeleton class="w-[52px] h-[16px] rounded-md" />
        </div>
      </div>
    </div>
    <div class="main-info__balance">
      <div class="main-info__balance-amount">
        <BaseSkeleton class="w-[180px] h-[24px] rounded-md mb-[9px]" />
      </div>
      <div class="main-info__balance-usd-value">
        <BaseSkeleton class="w-[100px] h-[16px] rounded-md" />
      </div>
    </div>
    <div class="main-info_details">
      <div v-for="index in 3" :key="index" class="main-info_details_item">
        <div class="main-info_details_item_label">
          <BaseSkeleton class="w-[40px] h-[16px] rounded-md mb-[5px]" />
        </div>
        <div class="main-info_details_item_value">
          <BaseSkeleton class="w-[150px] h-[16px] rounded-md mb-[20px]" />
        </div>
      </div>
      <div class="main-info_details_buttons">
        <BaseSkeleton class="w-full h-[36px] rounded-md" />
      </div>
    </div>
  </div>
</template>

<script setup>
// components
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";
</script>

<style lang="scss" scoped>
.main-info {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--Dark-900, #111);
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  overflow: hidden;

  &__balance {
    padding: 0 32px;
  }

  &_header {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 32px 32px 16px;

    &_left {
      margin-bottom: 9px;
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 13px;
    }

    &_icon {
      position: absolute;
      right: 32px;
      top: 32px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      pointer-events: none;
    }

    &_titles {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      margin-right: 12px;
    }
  }

  &_details {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding: 20px 32px 32px;

    &_buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }

    &_item {
      display: flex;
      flex-direction: column;

      &_label {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }

      &_value {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
      }
    }
  }
}
</style>
